import { Injectable } from '@angular/core';
import { OrderLine } from './orderLine';

@Injectable({
  providedIn:'root'
})

export class OrderHeader {
      public activeProduct?:string;
      public accountOwnerName?:string;
      public returnReason?:string;
      public senderCompanyName?:string;
      public receiverCompanyName?:string;
      public  accountOwnerId?: number;
      public productId?: string;
      public  senderMobile?: number;
      public  receiverMobile?: number;
      public  sourceWarehouseId?: number;
      public  accountOwnerContactId?: number;
      public accountOwnerCustomerId?:number;
      public  destWarehouseId?: number;
      public  destWarehouseName?: string;
      public  sourceWarehouseName?: string;
      public  contactName?: string;
      public  name?: string;
      public  orderType?: string;
      public  destinationWarehouseName?: string;
      public stockEntryNumber?: number;
      public  destWarehouseAddressText?: string;
      public  sourceWarehouseAddress?: string;
      public  warehouseAddressText?: string;
      public  destinationWarehouseAddress?: string;
      public  warehouseName?: string;
      public  orderStatus?: string;
      public  organizationId?: number;
      public  warehouseId?: number;
      public orderHeaderId?: number;
      public shippingMethod?: string;
      public productConfig?: string;
      public addressText?: string;
      public shippingOption?: string;
      public deliveryInstructions?: string;
      public id?: number;
      public  stockLinesList?: OrderLine[];
      public  shipLines?: OrderLine[];
       public  lines?: OrderLine[];
      public orderNumber?: number;
      public orderedDate?: string;
      public accountOwnerCustomerName?: string;
           // public orderNumber ?: string;
      public shipMethod ?: string;
      public totalValue ?: string;
      public paymentMethod ?: string;
      public senderName ?: string;
      public senderAddressText ?: string;
      public receiverName ?: string;
      public receiverAddressText ?: string;
      public additionalInfo ?: string;
      public connectionName ?: string;
      public providerStatus ?: string;
      public sourceOrderDate ?: string;
      public trackingNumber ?: string;
      public awbNumber ?: string;
      public sourceOrderId ?: number;
      public deliveryAreaPinCode ?: number;
      public pickupAreaPinCode ?: number;
      public weightOfOrder ?: number;
      public createdDate ?: string;
}
